var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "30",
      "text": "Please Wait. It may take a while for large number of records",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      class: {
        'col-md-12': item.type == 'heading' || item.type == 'detail' || item.type == 'excelDownload' || item.type == 'matrix' || item.type == 'CityZoneMatrix',
        'col-md-4': item.type == 'label',
        'col-md-11': item.type == 'table',
        'col-md-5': item.type == 'labelfordownload'
      },
      staticStyle: {
        "overflow": "auto"
      }
    }, [(item.type == 'heading') ? _c('div', {
      staticStyle: {
        "max-height": "100%",
        "padding": "0px 0px 5px 0px"
      }
    }, [_c('label', {
      staticClass: "card-header -filter_main",
      staticStyle: {
        "background-color": "#dddddd",
        "color": "black!important",
        "width": "100%",
        "height": "25px",
        "margin-bottom": "-1px",
        "padding": "3px 0px 5px 8px"
      }
    }, [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "form-group row",
      staticStyle: {
        "margin-bottom": "0rem"
      }
    }, _vm._l((item.value), function(item2, index) {
      return _c('div', {
        class: {
          'col-md-12': item2.type == 'detail' || item2.type == 'excelDownload' || item2.type == 'matrix' || item.type2 == 'CityZoneMatrix',
          'col-md-4': item2.type == 'label',
          'col-md-11': item2.type == 'table',
          'col-md-5': item2.type == 'labelfordownload'
        },
        staticStyle: {
          "width": "100%"
        }
      }, [(item2.type == 'labelfordownload') ? _c('div', {
        staticClass: "wordwrap"
      }, [(item2.key) ? _c('label', [_c('strong', [_vm._v(_vm._s(item2.key) + " : ")])]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(item2.value))]), _vm._v(" "), (item2.action && item2.action.type == 'download' && item2.action.value != null) ? _c('span', {
        staticStyle: {
          "cursor": "pointer",
          "color": "black"
        }
      }, [_vm._v("  "), _c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "margin": "1px"
        },
        attrs: {
          "aria-hidden": "true",
          "title": "Download Document"
        },
        on: {
          "click": function($event) {
            _vm.emitEvent(item2.action)
          }
        }
      })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item2.type == 'label') ? _c('div', {
        staticClass: "wordwrap"
      }, [(item2.key) ? _c('label', [_c('strong', [_vm._v(_vm._s(item2.key) + " : ")])]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(item2.value))]), _vm._v(" "), (item2.action && item2.action.type == 'download' && item2.action.value != null) ? _c('span', {
        staticStyle: {
          "cursor": "pointer",
          "color": "black"
        }
      }, [_vm._v("  "), _c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "margin": "1px"
        },
        attrs: {
          "aria-hidden": "true",
          "title": "Download Document"
        },
        on: {
          "click": function($event) {
            _vm.emitEvent(item2.action)
          }
        }
      })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item2.type == 'excelDownload') ? _c('div', {
        staticClass: "wordwrap"
      }, [(item2.key) ? _c('label', [_c('button', {
        staticClass: "-btn btn-link",
        attrs: {
          "type": "button",
          "title": "Download Rate"
        },
        on: {
          "click": function($event) {
            _vm.downloadFile(item2.value, item2.index)
          }
        }
      }, [_vm._v(_vm._s(item2.value.servicetype && item2.value.servicetype == 1 && item2.value.isexceptionalcity ?
        'Download Rate(Exceptional Lane)' :
        item2.value.servicetype && item2.value.servicetype == 2 ?
        'Download Rate(Zone to Zone)' :
        'Download Rate(City to City)'))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item2.type == 'detail') ? _c('div', {
        staticStyle: {
          "padding": "0px",
          "margin": "0px"
        }
      }, [(item2.key) ? _c('label', [_c('strong', [_vm._v(_vm._s(item2.key) + " : ")])]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(item2.value))])]) : _vm._e(), _vm._v(" "), (item2.type == 'table' && item2.value && item2.value.length > 0) ? _c('div', {
        staticClass: "col-md-8",
        staticStyle: {
          "max-height": "100%",
          "padding": "0px 0px 5px 0px"
        }
      }, [_c('table', {
        staticClass: "table-bordered table-hover tbl datatables",
        staticStyle: {
          "width": "100%",
          "margin-left": "33%"
        },
        attrs: {
          "id": "my-table"
        }
      }, [_c('thead', [_c('tr', {
        staticClass: "text-primary"
      }, _vm._l((item2.key), function(column, index) {
        return _c('th', {
          key: index
        }, [_vm._v(" " + _vm._s(column))])
      }))]), _vm._v(" "), _c('tbody', _vm._l((item2.value), function(data, index) {
        return _c('tr', _vm._l((item2.key), function(column, index) {
          return _c('td', [_vm._v(" " + _vm._s(data[column]))])
        }))
      }))])]) : _vm._e(), _vm._v(" "), (item2.type == 'matrix') ? _c('div', {
        staticClass: "col-md-12",
        staticStyle: {
          "max-height": "100%"
        }
      }, [_c('matrix', {
        attrs: {
          "isDisabled": true,
          "headerArray": item2.key,
          "tableDataArray": item2.value,
          "isSaveButtonHidden": true,
          "verticalHeaderArray": item2.verticalHeader,
          "label": item2.matrixLabel
        }
      })], 1) : _vm._e(), _vm._v(" "), (item2.type == 'CityZoneMatrix') ? _c('div', {
        staticClass: "col-md-12",
        staticStyle: {
          "max-height": "100%",
          "text-align": "center"
        }
      }, [_c('b-tabs', {
        staticClass: "tab-content1 tab-header1",
        staticStyle: {
          "margin-top": "5px",
          "width": "100%"
        },
        attrs: {
          "content-class": "mt-2"
        },
        model: {
          value: (_vm.tabIndex),
          callback: function($$v) {
            _vm.tabIndex = $$v
          },
          expression: "tabIndex"
        }
      }, [_c('b-tab', {
        staticClass: "tab-content1 tab-header1",
        attrs: {
          "title": "City to City",
          "title-link-class": _vm.linkClass(0)
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-12"
      }, [(item2.matrixHeaderCityArray.length > 0) ? _c('div', {
        staticClass: " matrix-section"
      }, [_c('matrix', {
        attrs: {
          "isDisabled": true,
          "headerArray": item2.matrixHeaderCityArray,
          "tableDataArray": item2.matrixTableDataCityArray,
          "isSaveButtonHidden": true,
          "label": item2.matrixLabel
        }
      })], 1) : _vm._e()])])]), _vm._v(" "), _c('b-tab', {
        staticClass: "tab-content1 tab-header1",
        attrs: {
          "title": "Territory to Territory",
          "title-link-class": _vm.linkClass(1)
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-12"
      }, [(item2.matrixHeaderZoneArray.length > 0) ? _c('div', {
        staticClass: "matrix-section"
      }, [_c('matrix', {
        attrs: {
          "isDisabled": true,
          "headerArray": item2.matrixHeaderZoneArray,
          "tableDataArray": item2.matrixTableDataZoneArray,
          "isSaveButtonHidden": true,
          "label": item2.matrixLabel
        }
      })], 1) : _vm._e()])])])], 1)], 1) : _vm._e()])
    }))])]) : _vm._e(), _vm._v(" "), (item.type == 'label') ? _c('div', {
      staticClass: "wordwrap"
    }, [_c('label', [_c('strong', [_vm._v(_vm._s(item.key) + " : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.action && item.action.type == 'download' && item.action.value != null) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "black"
      }
    }, [_vm._v("  "), _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "margin": "1px"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Document"
      },
      on: {
        "click": function($event) {
          _vm.emitEvent(item.action)
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 'detail') ? _c('div', {
      staticClass: "wordwrap"
    }, [_c('label', [_c('strong', [_vm._v(_vm._s(item.key) + " : ")])]), _vm._v(" "), _c('label', {
      staticClass: "wordwrap"
    }, [_vm._v(_vm._s(item.value))])]) : _vm._e(), _vm._v(" "), (item.type == 'excelDownload') ? _c('div', {
      staticClass: "wordwrap"
    }, [(item.key) ? _c('label', [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.downloadFile(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.value.servicetype && item.value.servicetype == 1 && item.value.isexceptionalcity ?
      'Download Rate(Exceptional Lane)' :
      item.value.servicetype && item.value.servicetype == 2 ?
      'Download Rate(Zone to Zone)' :
      'Download Rate(City to City)'))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 'labelfordownload') ? _c('div', {
      staticStyle: {
        "padding": "0px",
        "margin": "0px"
      }
    }, [_c('label', [_c('strong', [_vm._v(_vm._s(item.key) + " : ")])]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.action && item.action.type == 'download' && item.action.value != null) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "black"
      }
    }, [_vm._v("  "), _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "margin": "1px"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Document"
      },
      on: {
        "click": function($event) {
          _vm.emitEvent(item.action)
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 'table' && item.value && item.value.length > 0) ? _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "max-height": "100%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "width": "103%",
        "margin-left": "0%"
      },
      attrs: {
        "id": "my-table"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "text-primary"
    }, _vm._l((item.key), function(column, index) {
      return _c('th', {
        key: index,
        staticClass: "text-nowrap"
      }, [_vm._v(" " + _vm._s(column) + " ")])
    }))]), _vm._v(" "), _c('tbody', _vm._l((item.value), function(data, index) {
      return _c('tr', _vm._l((item.key), function(column, index) {
        return _c('td', [_vm._v(" " + _vm._s(data[column]))])
      }))
    }))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.type == 'matrix') ? _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "max-height": "100%"
      }
    }, [_c('matrix', {
      attrs: {
        "isDisabled": true,
        "headerArray": item.key,
        "tableDataArray": item.value,
        "isSaveButtonHidden": true,
        "verticalHeaderArray": item.verticalHeader,
        "label": item.matrixLabel
      }
    }), _c('br')], 1) : _vm._e(), _vm._v(" "), (item.type == 'CityZoneMatrix') ? _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "max-height": "100%",
        "text-align": "center"
      }
    }, [_c('b-tabs', {
      staticClass: "tab-content1 tab-header1",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "content-class": "mt-2"
      },
      model: {
        value: (_vm.tabIndex),
        callback: function($$v) {
          _vm.tabIndex = $$v
        },
        expression: "tabIndex"
      }
    }, [_c('b-tab', {
      staticClass: "tab-content1 tab-header1",
      attrs: {
        "title": "City to City",
        "title-link-class": _vm.linkClass(0)
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item.matrixHeaderCityArray.length > 0) ? _c('div', {
      staticClass: "matrix-section"
    }, [_c('matrix', {
      attrs: {
        "isDisabled": true,
        "headerArray": item.matrixHeaderCityArray,
        "tableDataArray": item.matrixTableDataCityArray,
        "isSaveButtonHidden": true,
        "label": item.matrixLabel
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), _c('b-tab', {
      staticClass: "tab-content1 tab-header1",
      attrs: {
        "title": "Territory to Territory",
        "title-link-class": _vm.linkClass(1)
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item.matrixHeaderZoneArray.length > 0) ? _c('div', {
      staticClass: "matrix-section"
    }, [_c('matrix', {
      attrs: {
        "isDisabled": true,
        "headerArray": item.matrixHeaderZoneArray,
        "tableDataArray": item.matrixTableDataZoneArray,
        "isSaveButtonHidden": true,
        "label": item.matrixLabel
      }
    })], 1) : _vm._e()])])])], 1)], 1) : _vm._e()])
  })], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5e8f06","hasScoped":true}!./src/modules/shared/components/viewdetails/viewDetails.component.html
// module id = 675
// module chunks = 3